
export const LIGHT_COLOUR = "var(--color-player-light)";
export const DARK_COLOUR = "var(--color-player-dark)";
